import { makeStyles } from '../../../styles';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& .MuiPaper-root': Object.assign(Object.assign({}, theme.typography.body2), { color: theme.colors.text[900], background: theme.colors.primary.contrastWhite, borderColor: theme.colors.gray[200], borderWidth: 1, borderStyle: 'solid', borderRadius: 8, '& .MuiAlert-icon': {
                marginRight: theme.spacing(1),
            } }),
        '&.highlighted': {
            '& .MuiPaper-root': {
                borderColor: theme.colors.primary.main,
            },
        },
    },
    alert: {
        marginBottom: theme.spacing(2),
    },
    iconButton: {
        border: 'none',
        '& .MuiSvgIcon-root': {
            fill: theme.colors.text[700],
        },
    },
}));
export default useStyles;
//# sourceMappingURL=Banner.styles.js.map